import { API_ENDPOINTS } from "@/api/services/profile/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const hrInformationApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    fetchReportingManager: builder.query({
      query: () => ({
        url: API_ENDPOINTS.HR_INFORMATION.FETCH_REPORTING_MANAGER,
        method: "GET",
      }),
      providesTags: [{ type: "hrInformation", id: "LIST" }],
    }),
    fetchDivisionHead: builder.query({
      query: () => ({
        url: API_ENDPOINTS.HR_INFORMATION.FETCH_DIVISION_HEAD,
        method: "GET",
      }),
      providesTags: [{ type: "hrInformation", id: "LIST" }],
    }),
    fetchReviewer: builder.query({
      query: () => ({
        url: API_ENDPOINTS.HR_INFORMATION.FETCH_REVIEWER,
        method: "GET",
      }),
      providesTags: [{ type: "hrInformation", id: "LIST" }],
    }),
    fetchRecruiter: builder.query({
      query: () => ({
        url: API_ENDPOINTS.HR_INFORMATION.FETCH_REPORTING_MANAGER, // Using same endpoint as reporting manager for now
        method: "GET",
      }),
      providesTags: [{ type: "hrInformation", id: "LIST" }],
    }),
    fetchOnboarder: builder.query({
      query: () => ({
        url: API_ENDPOINTS.HR_INFORMATION.FETCH_REPORTING_MANAGER, // Using same endpoint as reporting manager for now
        method: "GET",
      }),
      providesTags: [{ type: "hrInformation", id: "LIST" }],
    }),
    fetchBuddy: builder.query({
      query: () => ({
        url: API_ENDPOINTS.HR_INFORMATION.FETCH_REPORTING_MANAGER, // Using same endpoint as reporting manager for now
        method: "GET",
      }),
      providesTags: [{ type: "hrInformation", id: "LIST" }],
    }),
    fetchHrInfo: builder.query({
      query: () => ({
        url: API_ENDPOINTS.HR_INFORMATION.FETCH_HR_INFO,
        method: "GET",
      }),
      providesTags: [{ type: "hrInformation", id: "LIST" }],
    }),

    updateHrInfo: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.HR_INFORMATION.EDIT_HR_INFO,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "hrInformation", id: "LIST" }],
    }),

    // hr Api
    hrFetchHrInfo: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.HR_INFORMATION.HR_FETCH_HR_INFO(empId),
        method: "GET",
      }),
      providesTags: [{ type: "hrHrInfo", id: "LIST" }],
    }),

    hrUpdateHrInfo: builder.mutation({
      query: ({ empId, formData }) => ({
        url: API_ENDPOINTS.HR_INFORMATION.HR_EDIT_HR_INFO(empId),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "hrHrInfo", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchReportingManagerQuery,
  useFetchDivisionHeadQuery,
  useFetchReviewerQuery,
  useFetchRecruiterQuery,
  useFetchOnboarderQuery,
  useFetchBuddyQuery,
  useFetchHrInfoQuery,
  useUpdateHrInfoMutation,
  useHrFetchHrInfoQuery,
  useHrUpdateHrInfoMutation,
} = hrInformationApi;
